import { createAsyncThunk } from "@reduxjs/toolkit";
import { AxiosClient } from "../AxiosClient";

export const getPracticeTestsAsync = createAsyncThunk(
  "user/getPracticeTests",
  async (payload, toolkit) => {
    return await AxiosClient("POST", `/getPracticeTests`, payload, toolkit);
  }
);

// export const userStudyMatrialsAsync = createAsyncThunk(
//   "user/userStudyMatrials",
//   async (payload, toolkit) => {
//     return await AxiosClient(
//       "GET",
//       `/userStudyMatrials?subjectId=${payload?.subjectId || ""}&chapterId=${
//         payload?.chapterId || ""
//       }&type=${payload?.type || ""}&materialId=${payload?.materialId || ""}`,
//       payload,
//       toolkit
//     );
//   }
// );
